import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { ErrorHandler } from '../utils/errorHandler';
import authService from '../services/authService';

const ProtectedRoute = ({ children }) => {
  console.log('🔐 ProtectedRoute iniciando render...', {
    hasChildren: !!children,
    childrenType: typeof children
  });

  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    console.log('🔐 ProtectedRoute useEffect iniciando validação...');

    const validateAuthentication = async () => {
      try {
        console.log('🔍 Validando autenticação...');
        const token = localStorage.getItem('token');

        // Verificar se existe token
        if (!token) {
          console.log('❌ Nenhum token encontrado');
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }

        console.log('✅ Token encontrado, validando estrutura...');

        // Verificar se o token é válido estruturalmente
        if (!ErrorHandler.isTokenValid(token)) {
          console.warn('⚠️ Token inválido ou expirado');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }

        console.log('✅ Token estruturalmente válido, validando com servidor...');

        // Validar token com o servidor
        try {
          const isValid = await authService.validateToken();
          console.log('🔐 Resultado da validação do servidor:', isValid);
          setIsAuthenticated(isValid);
        } catch (error) {
          console.error('❌ Erro ao validar token:', error);

          // Se for erro de autenticação, limpar dados
          if (error.response?.status === 401 || error.response?.status === 403) {
            console.log('🚪 Erro de autenticação, limpando dados...');
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            setIsAuthenticated(false);
          } else {
            // Para outros erros, assumir autenticado se o token é estruturalmente válido
            // (problema de rede não deve deslogar o usuário)
            console.log('⚠️ Erro de rede, assumindo autenticado...');
            setIsAuthenticated(true);
          }
        }
      } catch (error) {
        console.error('❌ Erro na validação de autenticação:', error);
        setIsAuthenticated(false);
      } finally {
        console.log('🔐 Finalizando validação...');
        setIsLoading(false);
      }
    };

    validateAuthentication();
  }, []);

  console.log('🔐 ProtectedRoute state atual:', {
    isAuthenticated,
    isLoading
  });

  // Mostrar loading enquanto valida
  if (isLoading) {
    console.log('⏳ ProtectedRoute renderizando loading...');
    return (
      <div className="auth-loading">
        <div className="spinner"></div>
        <p>Verificando autenticação...</p>
      </div>
    );
  }

  // Redirecionar para login se não autenticado
  if (!isAuthenticated) {
    console.log('🚪 ProtectedRoute redirecionando para login...');
    return <Navigate to="/login" replace state={{
      message: 'Por favor, faça login para acessar esta página.'
    }} />;
  }

  // Renderizar componente protegido
  console.log('✅ ProtectedRoute renderizando children...');

  // Validar children antes de renderizar
  if (!children) {
    console.error('❌ CRÍTICO: ProtectedRoute sem children!');
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Erro de configuração</h2>
        <p>Rota protegida sem conteúdo</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
